import React, { useContext } from 'react';
import cn from 'classnames';
import ConfigContext from '../../../contexts/ConfigContext';
import TermSearch from './TermSearch';

import styles from './Header.module.postcss';

function MobileSearch({ mobileSearchOpen }) {
  const config = useContext(ConfigContext);
  if (config.serverSide) return null;

  return (
    <div
      className={cn(styles.MobileSearch, {
        [styles.MobileSearch_open]: mobileSearchOpen,
      })}
    >

      <TermSearch isMobile />

    </div>
  );
}

export default MobileSearch;
